import React, { useState } from 'react'
import { Row } from '@zendeskgarden/react-grid'
import { Modal, Close } from '@zendeskgarden/react-modals'
import { Field, MediaInput, Label } from '@zendeskgarden/react-forms'
import { Button } from '@zendeskgarden/react-buttons'
import styled from 'styled-components'
import DismissIcon from '@zendeskgarden/svg-icons/src/16/x-fill.svg'
import { useStateWithLocalStorage } from './localStorage'
import CreateSubscriptionRequest from './CreateSubscriptionRequest'
import { getQueryVariable } from './utils'

const StyledRow = styled(Row)`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 5px;
`
const StyledField = styled(Field)`
  width: 620px;
  height: 40px;
`

const StyledLabel = styled(Label)`
  font-size: 14px
`

const StyledDiv = styled.div`
  margin: 10px;
`

const StyledDismissIcon = styled(DismissIcon)`
  cursor:pointer;
  float:right;
`

const SubDomain = ({ subdomain, onSearch, showSubscription, flash, setSuccessFlash, setErrorFlash }) => {
  const [domain, setDomain] = (getQueryVariable('subdomain') && useState(getQueryVariable('subdomain'))) || useStateWithLocalStorage('mySubDomainLocalStorage')
  const [subscriptionCreateShowing, setSubscriptionCreateShowing] = useState(false)

  const onModalClose = () => {
    setSubscriptionCreateShowing(false)
  }

  const domainScrub = domain => {
    let curDomain = domain.toLowerCase()
    const suffix = '.zendesk.com'
    if (curDomain.substr(curDomain.length - suffix.length) === suffix) {
      curDomain = curDomain.substr(0, curDomain.length - suffix.length)
    }
    return curDomain
  }

  const handleKeyDown = event => {
    if (event.keyCode === 13 && domain.length <= 50) {
      const curDomain = domainScrub(domain)
      onSearch(curDomain)
    }
  }

  const validateDomainLength = event => {
    if (event.target.value.trim().length <= 50) {
      setDomain(event.target.value.trim())
    }
  }

  const clearDomain = () => {
    setDomain('')
    onSearch('')
  }

  const StyledDismiss = () => {
    return (
      <StyledDismissIcon onClick={() => clearDomain()} />
    )
  }

  const shouldDisableButton = () => {
    const isErrorShowing = flash.constructor === Object && Object.keys(flash).length !== 0
    const noSubdomain = !subdomain
    const noSubdomainOrErrorShowing = noSubdomain || isErrorShowing
    const subdomainAndErrorShowing = subdomain && isErrorShowing

    return noSubdomainOrErrorShowing || subdomainAndErrorShowing
  }

  if (!subscriptionCreateShowing) {
    return (
      <StyledRow>
        <StyledField>
          <StyledLabel>Subdomain</StyledLabel>
          <MediaInput id='clear-subdomain' placeholder="Enter your Zendesk subdomain" value={domain} onChange={event => validateDomainLength(event)} onKeyDown={event => handleKeyDown(event)} end={<StyledDismiss />} />
        </StyledField>
        <Button type="button" onClick={() => {onSearch(domainScrub(domain))}} style={{ marginTop: "60px" }}>
          Check status
        </Button>
        <Button
          type="button"
          onClick={() => setSubscriptionCreateShowing(true)}
          disabled={shouldDisableButton()}
          style={{ marginTop: "60px" }}>
          Subscribe
        </Button>
      </StyledRow>
    )
  }
  return (
    <Modal onClose={onModalClose} medium animate>
      <CreateSubscriptionRequest
        subdomain={subdomain}
        onClose={onModalClose}
        setSuccessFlash={setSuccessFlash}
        setErrorFlash={setErrorFlash}
      />
      <Close aria-label="Close modal" />
    </Modal>
  )
}

export default SubDomain
